import { Menu, MenuList, PopoverProps, Divider } from '@mui/material';
import { FC } from 'react';

import { DataGridActions } from './DataGridAction';
import { DataGridActionMenuItem } from './DataGridActionMenuItem';

export interface DataGridActionMenuProps {
  id: number;
  row?: any;
  open: boolean;
  onClose: () => void;
  anchor: PopoverProps['anchorEl'];
  actions: DataGridActions;
}

export const DataGridActionMenu: FC<DataGridActionMenuProps> = ({
  id,
  row,
  open,
  onClose,
  anchor,
  actions,
}) => {
  const editMenuItem = actions.edit ? (
    <DataGridActionMenuItem {...actions.edit} type="edit" id={id} row={row} />
  ) : null;
  const deleteMenuItem = actions.delete ? (
    <DataGridActionMenuItem {...actions.delete} type="delete" id={id} row={row} />
  ) : null;
  const viewMenuItem = actions.view ? (
    <DataGridActionMenuItem {...actions.view} type="view" id={id} row={row} />
  ) : null;
  const otherMenuItems = actions.other
    ? Object.entries(actions.other).map(([key, action]) => (
        <DataGridActionMenuItem
          key={key}
          {...action}
          type="other"
          actionType={action.actionType}
          id={id}
          row={row}
        />
      ))
    : null;

  return (
    <Menu
      id="basic-menu"
      anchorEl={anchor}
      open={open}
      onClose={onClose}
      MenuListProps={{
        'aria-labelledby': 'basic-button',
      }}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      <MenuList>
        {viewMenuItem}
        {editMenuItem}
        {otherMenuItems && (editMenuItem || viewMenuItem) && <Divider />}
        {otherMenuItems}
        {deleteMenuItem && <Divider />}
        {deleteMenuItem}
      </MenuList>
    </Menu>
  );
};

export default DataGridActionMenu;
